import {
  getMachineHealthAPI,
  getMachineHealthAlertsAPI,
  getMachineHealthHistoryAPI,
} from '../adapters/MachineHealthAdapter/MachineHealthAdapter';

const extractData = (res) => {
  if (res?.status === 200 && res?.data?.status === '200') {
    return res.data.data;
  }
  const message = res?.data?.data?.message;
  const err = new Error(message || 'Request failed');
  err.apiStatus = res?.data?.status;
  throw err;
};

const wrapRequest = (request) => new Promise((resolve, reject) => {
  request
    .then((res) => resolve(extractData(res)))
    .catch((err) => {
      const message = err?.response?.data?.data?.message
        || err?.message
        || 'error occurred';
      const wrapped = new Error(message);
      wrapped.httpStatus = err?.response?.status;
      wrapped.apiStatus = err?.response?.data?.status;
      reject(wrapped);
    });
});

export const getMachineHealth = (machineUDI) => wrapRequest(getMachineHealthAPI(machineUDI));

export const getMachineHealthHistory = (machineUDI, options = {}) => wrapRequest(
  getMachineHealthHistoryAPI(machineUDI, options)
);

export const getMachineHealthAlerts = (machineUDI, options = {}) => wrapRequest(
  getMachineHealthAlertsAPI(machineUDI, options)
);
